import Hash from "../../utils/hash";
import Vue from "vue";
import launch from "../../utils/launch";

var jsonLogic = require("json-logic-js"); // jsonLogic.add_operation("add_ms", function(a, b) {
//   if (Utils.type.isString(a)) {
//     const newValue = new Date(new Date(a).getTime() + b * 1000);
//     return newValue.toISOString();
//   }
//   return null;
// });


export default {
  data: function data() {
    return {
      _fieldModels: {},
      fieldName: null,
      fieldModel: null,
      // Some components do not support null or empty string value, so we need to use an intermediary value.
      // See https://github.com/vuetifyjs/vuetify/issues/8876
      vuetifyEmptyString: "<EMPTY_STRING>"
    };
  },
  computed: {
    display: function display() {
      var conditions = this.spec.showIf;

      if (conditions) {
        return jsonLogic.apply(conditions, this.$data._fieldModels) ? this.$displayValue() : "none";
      } else {
        return this.$displayValue();
      }
    }
  },
  watch: {
    fieldModel: function fieldModel(val, oldVal) {
      if (val === this.vuetifyEmptyString) {
        val = "";
      } // Make the field property observable for dynamic showing/hiding


      Vue.set(this.$data._fieldModels, this.fieldName, this.$internalizeValue(val));

      this._checkDirtyState(val, oldVal);
    }
  },
  methods: {
    // TODO: Deprecated
    genericStyles: function genericStyles(spec) {
      return this.$styles(spec);
    },
    _checkDirtyState: function _checkDirtyState(val, oldVal) {
      var dirtyCheckEnabled = !this.spec.disableDirtyCheck; // Make sure value has changed and make sure that it is different from the original value.
      // Be strict with this so it doesn't execute when the component is just initializing (e.g value changing
      // from `null` to `this.spec.value`).

      if (dirtyCheckEnabled && val != oldVal && val != this.spec.value) {
        var topDialog = Utils.launch.dialog.topDialog();

        if (topDialog) {
          if (!topDialog.isFormDirty) {
            console.log("Dialog form is now dirty");
            topDialog.isFormDirty = true;
          }
        } else {
          if (!window.vueApp.isFormDirty) {
            console.log("Window form is now dirty");
            window.vueApp.isFormDirty = true;
          }
        }
      }
    },
    // NOTE: Styles are dynamic, do not save it in $ready().
    $styles: function $styles(spec) {
      var properties = spec || this.spec;
      var styles = {// color: properties.color,
        // "background-color": properties.backgroundColor,
        // "text-align": properties.textAlign
      };
      Utils.type.ifString(properties.color, function (val) {
        return styles["color"] = val;
      });
      Utils.type.ifString(properties.backgroundColor, function (val) {
        return styles["background-color"] = val;
      });
      Utils.type.ifString(properties.textAlign, function (val) {
        return styles["text-align"] = val;
      });
      Utils.type.ifObject(properties.padding, function (padding) {
        Utils.type.ifNumber(padding.top, function (top) {
          return styles["padding-top"] = "".concat(top, "px");
        });
        Utils.type.ifNumber(padding.bottom, function (bottom) {
          return styles["padding-bottom"] = "".concat(bottom, "px");
        });
        Utils.type.ifNumber(padding.left, function (left) {
          return styles["padding-left"] = "".concat(left, "px");
        });
        Utils.type.ifNumber(padding.right, function (right) {
          return styles["padding-right"] = "".concat(right, "px");
        });
      });
      Utils.type.ifString(this.$length(properties.width), function (val) {
        return styles["width"] = val;
      });
      Utils.type.ifString(this.$length(properties.height), function (val) {
        return styles["height"] = val;
      });
      Utils.type.ifObject(properties.onClick, function () {
        return styles["cursor"] = "pointer";
      }); // This is the main reason styles have to be used in a dynamic way.

      this._updateDisplay(styles, properties);

      return new Hash(styles);
    },
    $length: function $length(length) {
      if (Utils.type.isString(length) || Utils.type.isNumber(length)) {
        switch (length) {
          case "wrapContent":
            return null;

          case "matchParent":
            return "100%";

          default:
            return "".concat(length, "px");
        }
      }

      return null;
    },
    $builtinColor: function $builtinColor(styleClasses) {
      var color = null;
      Utils.type.ifArray(styleClasses, function (classes) {
        for (var _i = 0, _arr = ["success", "info", "warning", "error"]; _i < _arr.length; _i++) {
          var val = _arr[_i];

          if (classes.remove(val)) {
            color = val;
          }
        }
      });
      return color;
    },
    _updateDisplay: function _updateDisplay(styles, properties) {
      var _this = this;

      Utils.type.ifObject(properties.showIf, function () {
        return styles["display"] = _this.display;
      });
      Utils.type.ifObject(properties.valueIf, function (logic) {
        var newValue = jsonLogic.apply(logic, _this.$data._fieldModels);
        _this.fieldModel = _this._sanitizeValue(_this.$externalizeValue(newValue));
      });
    },
    $displayValue: function $displayValue() {
      // return "block"; Deprecated because it causes problems for multiple rows components
      // return "inherit"; // To be overridden
      // Use null so we don't accidentally override existing styling. Without this, the
      // `_read_more_text` garage example will not work.
      return null;
    },
    _sanitizeValue: function _sanitizeValue(val) {
      return Utils.type.isNotNull(val) ? this.$sanitizeValue(val) : null;
    },
    $sanitizeValue: function $sanitizeValue(val) {
      return val; // To be overridden
    },
    $internalizeValue: function $internalizeValue(val) {
      return val;
    },
    $externalizeValue: function $externalizeValue(val) {
      return val;
    },
    _linkFieldModels: function _linkFieldModels() {
      var hasCondition = this.spec && this.spec.showIf;
      var name = Utils.app.vueName(this);
      var isField = name && name.startsWith("fields-");

      if (hasCondition || isField) {
        var form = this.$closest("panels-form");

        if (form != null) {
          this.$data._fieldModels = form.$data._fieldModels;
        } // Has to be executed before $ready(). This executes regardless of whether a form is found because fields
        // may be used without a form.


        this.fieldName = this.spec.name; // Don't initialize fieldModel unnecessarily because this will trigger validations on page load

        if (this.spec.value) {
          this.fieldModel = this._sanitizeValue(this.spec.value);
        }
      }
    },
    $classes: function $classes(spec) {
      var properties = spec || this.spec;
      var componentName = Utils.app.componentName(properties.view);
      var classes = (properties.styleClasses || []).concat(componentName);
      Utils.type.ifArray(properties.styleClasses, function (val) {
        if (val.includes("card")) {
          classes.push("v-card");
          classes.push("v-sheet");
          classes.push("theme--light");

          if (val.includes("outlined")) {
            classes.push("v-sheet--outlined");
          }
        }
      });
      return classes;
    }
  }
};